






















































import { Component, Vue } from "vue-property-decorator";
import { EventBus } from "../event-bus";
import axios from "axios";
import { Token } from "../utils/Token";
import store from "@/store";
import {UsbStatusModel} from "@/models/UsbStatus";
import UsbStatus from "./UsbStatus.vue";


@Component({
  components: {},
  /*filters:{
    transformStatusIcon(value:any){
      //100 running //400 error //200 not running
      return value==200? "mdi-information-variant": value==400?"mdi-alpha-x": this.usbStatusIcon.CheckFileFinished?"chevron-down":"mdi-spin";
    }
  },*/
})
export default class Header extends Vue {
  public errorModalFlag = false;
  public errorText = "";
  public errorTitle = "";
  public showUbStatusInfo=false;
  public delayFlag=false;
  public usbStatusIcon=new UsbStatusModel();

  public transformStatusIcon():string{
          //100 running //400 error //200 not running
          //100 + filefinished finished
    return this.usbStatusIcon.Running==400?"mdi-close-circle-outline":"mdi-check-circle-outline";
  }
  
  
  created() {
    EventBus.$off('closeErrorModal');
    EventBus.$off('LogOutEventBus');
    EventBus.$off('refreshUsbStatus');

    EventBus.$on("closeErrorModal", (value: boolean) => {
      this.errorModalFlag = value;
    });

    EventBus.$on("refreshUsbStatus", (value: UsbStatusModel) => {
        //100 running //400 error //200 not running
        //if error occured show error
        //if full transferring occurred show completion
        //if not running don't show

        //if error or finish (delayFlag=true) get message and delay. 
        //if delay finish (delayFlag=false) get value and show icon if running
        //if delay finish (delayFlag=false) get value and don't show icon if not running
        //if running (delayFlag=false and running=100) show icon.
        if (!this.delayFlag){
              this.usbStatusIcon = value;
              if (this.usbStatusIcon.Running==200 ){
                this.setShowUsbStatusInfo(false);
              }else{
                this.setShowUsbStatusInfo(true);
              }
        }

        if (value.Error!=undefined || value.CheckFileFinished){
          this.delayFlag=true;
          this.delay(1000*this.$store.state.delayTime);//secTime*numOfSecs
          console.log("delay started header")
        }        
        
    });

    EventBus.$on("LogOutEventBus", (value: boolean) => {
      console.log("logout bus");
      const token = Token.getTokenWithExpiry("token");

      this.removeEventListeners();

      this.$store.state.loggedOut=true;
      this.$store.dispatch('closeSockets');
      axios({
        method: "get",
        withCredentials: true,
        url: `${process.env.VUE_APP_BASE_URL}/logout`,
      })
        .then((response) => {

          console.log("response of logout:", response);
          Token.removeTokens();
          this.$router.push({ name: "Login" });

        })
        .catch((err) => {
          console.log("error:", err);
        });
    });
  }

  private setShowUsbStatusInfo(value:boolean){
    this.showUbStatusInfo=value;
  }
  private removeEventListeners(){
    EventBus.$off('eventLogs');

  }
   
  private setDelayFlag(value:boolean){
    this.delayFlag=value;
  }
   
  public delay = (time:number) => {
     setTimeout(() =>{
       this.setDelayFlag(false);
       console.log("delay finished header");
     },time); //delay is in milliseconds 
  }

  public async logout() {
    const token = await Token.getTokenWithExpiry("token");
    this.$store.state.loggedOut=true;
    this.$store.dispatch('closeSockets');
    this.removeEventListeners();
    axios({
      method: "get",
      withCredentials: true,
      url: `${process.env.VUE_APP_BASE_URL}/logout`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
    })
      .then((response) => {

        console.log("response of logout:", response);
        Token.removeTokens();
        this.$router.push({ name: "Login" });
      })
      .catch((err) => {
        console.log("error:", err);
      });
  }

  public navigateToChangePasswordPage(): void {
    this.$router.push({ name: "ChangePassword" });
  }

  get showChangePassword(): boolean {
    return this.$route.name == "ChangePassword" ? false : true;
  }

  public usbStatusInfo():void{
    console.log("header modal status:",this.usbStatusIcon)
    EventBus.$emit("changeUsbStatusModal",true,this.usbStatusIcon ); 
  }
}
